var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{class:['back-btn', { 'fixed': _vm.fixed }],attrs:{"depressed":"","height":"32"},on:{"click":_vm.onBackClick}},[_c('v-icon',{staticClass:"mr-1",attrs:{"size":"15"}},[_vm._v("mdi-arrow-left")]),_vm._v(" "+_vm._s(_vm.$t('common.back'))+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }